import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Ref } from 'vue-property-decorator';
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';
import EdInputModel from '@/models/ed-input.model';
import Moment from 'moment';

@Component({
  name: 'ed-list-class-teachers'
})
export default class EdListClassTeachersComponent extends Vue {
    
  /* Props */
  @Prop() readonly classItem: any;
  @Prop() readonly orgId: number;

  @Ref('dataTable') readonly dataTable: any;
  
  /* Data */
  public search = EdInputModel('search',  '');
  public loading: boolean = true;
  public loadingAdd: boolean = false;
  public addObj: Object = {};
  public teachers: any = [];
  public teachersOrg: any = [];
  public inviteTeacher: boolean = false;
  public mainTeacherRadio: boolean = true;
  public paginationService: object = {
    current: 1,
    total: 0,
    previousTotal: 0
  }
  public paginationStore: object = {
    current: 1,
    total: 0
  }
  private ROWS_PER_PAGE: number = 10; 
  private EMPTY_STRING: string = '';

  /* Computed */
  get  headers() { 
    return [
      { text: this.$t('classes.headers.username'), align: 'start', value: 'username', show: true },
      { text: this.$t('classes.headers.name'), value: 'firstName', show: true },
      { text: this.$t('classes.headers.lastName'), value: 'lastName', show: true },
      { text: this.$t('classes.headers.email'), value: 'email', show: true  },
      { text: this.$t('classes.headers.teacherType'), value: 'teacherType', show: true  },
      { text: this.$t('classes.headers.mainTeacher'), value: 'mainTeacher', show: this.writeClassPriv, sortable: false },
      { text: this.$t('classes.headers.actions'), value: 'actions', sortable: false, show: true }
    ].filter(el => el.show)
  }

  get classTeachers() {
    return this.$store.state.ClassesStore.classTeachers;
  }

  get pagedOrganizationTeachers() {
    return this.$store.state.ClassesStore.pagedOrganizationTeachers;
  }

  get writeClassPriv() {
    return this.$store.state.AuthStore.privileges.WriteClass;
  }

  get isMainTeacher() {
    return this.$store.state.AuthStore.user.id === this.classItem.teacher.id
  }

  get isCalendarExpired() {
    return Moment(this.classItem.schoolDay?.endDate).isBefore(Moment());
  }
 
  /* Methods */
  deleteItem (item: Object) {
    this.$EdModal.createConfirmationModal(
      {
        body: this.$t('classes.teachers.confirmRemove', 
          {
            teacherName:  item['firstName'] || item['person']['fullName'], 
            className: this.classItem.name
          }), 
        action: async () => {
          await this.deleteItemConfirm(item);
        }
      }
    );
  }
 
  deleteItemConfirm (item) {
    let teacherType
    if(item.person) teacherType = item.type
    else teacherType = this.getTeacherType(item)
    let actionName = teacherType == 'COURSE_TEACHER' ? CLASSES_STORE.ACTIONS.REMOVE_COURSE_TEACHER_FROM_CLASS_A : CLASSES_STORE.ACTIONS.REMOVE_TEACHER_FROM_CLASS_A;
    this.$store.dispatch(`${actionName}`, 
    { classId: this.classItem.id,
    teacherId: item.personId || item.person?.id}
    ).then(() => {
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.success.teacherRemoved')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this._loadTeachersInDataTable();
    }).catch(() => {
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.errors.teacherNoRemoved')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    })
  }
 
  addTeacherToClass(teacher) {
    this.loadingAdd = true;
    this.addObj = teacher;
    this.dataTable?.updateItem(teacher);
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.ADD_TEACHER_TO_CLASS_A}`, 
      { classId: this.classItem.id,
        teacherId: teacher.personId}
    ).then(() => {
      this.loadingAdd = false;
      this.addObj = {};
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.success.teacherAdded')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
    }).catch(() => {
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.errors.teacherNoAdded')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    })
  }
 
  getClassTeachers() {
    this.loading = true;
    
    // Get All Class Teachers
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.GET_CLASS_TEACHERS_A}`,{
      classId: this.classItem.id
    }).then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    })
  }
 
  getOrganizationTeachers() {
    if(this.isCalendarExpired) 
      return;

    this.loading = true;
    this.inviteTeacher = true;
    // Check with store if the page was loaded previously    
    this.teachersOrg = this.pagedOrganizationTeachers.find(el => el.page === this.paginationService['current']-1)?.content;
     // Fetch new page
    if (!this.teachersOrg) {
      this.$store.dispatch(`${CLASSES_STORE.ACTIONS.GET_ORGANIZATION_TEACHERS_A}`,{
        orgId: this.orgId, page: this.paginationService['current']-1, pageSize: this.ROWS_PER_PAGE, orderByClassId: this.classItem.id
      }).then((res) => { 
        this.teachersOrg = res.content;
        this.paginationService['total'] = res.totalPages;
        this.paginationService['previousTotal'] = res.totalPages;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.inviteTeacher = false;
        this.teachersOrg = [];
      })
    } else {
      this.loading = false;
      this.paginationService['total'] = this.paginationService['previousTotal'];
      this._loadTeachersInDataTable();
    }
  }
 
  onPageChange() {
    this.getOrganizationTeachers();
  }

  updateMainTeacherConfirm(teacher) {
    if(this.isCalendarExpired)
      return;
    this.$EdModal.createConfirmationModal(
      {
        body: this.$t('classes.teachers.confirmMainTeacher', 
          {
            teacherName:  teacher['firstName'] || teacher['person']['fullName'], 
            className: this.classItem.name
          }), 
        action: async () => {
          await this.updateMainTeacher(teacher);
        }
      }
    );
  }
 
  updateMainTeacher(teacher) {
    this.mainTeacherRadio = null;
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.UPDATE_MAIN_TEACHER_A}`,{
      classId: this.classItem.id, teacherId: teacher.personId || teacher.person.id,
      prevMainTeacher: this.classItem.teacher.id
    }).then(() => { 
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.success.mainTeacherUpdated')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.mainTeacherRadio = true;
    }).catch(() => {
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.errors.mainTeacherNoUpdated')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    })
  }

  getTeacherType(item) {
    let teacher = this.classTeachers.find(el => el.person.id === item.personId)
    return teacher?.type
  }

  getTeacherTypeName(type) {
    switch(type){
      case 'TEACHER':
        return this.$t('classes.headers.mainTeacher')
      case 'CO_INSTRUCTOR':
        return this.$t('classes.teachers.coTeacher')
      case 'COURSE_TEACHER':
        return this.$t('classes.teachers.courseTeacher')
      case 'SUBSTITUTE_TEACHER':
        return this.$t('classes.teachers.substituteTeacher')
      default:
        return null
    }
  }

  substituteTeacher(item): boolean {
    let typeId = item?.type
    return typeId == 'SUBSTITUTE_TEACHER';
  }

  goBack(): void {
    this.inviteTeacher = !this.inviteTeacher; 
    this.search.value = this.EMPTY_STRING;
    this._loadTeachersInDataTable();
  }

  public onPageUpdate(customEvent: CustomEvent): void {
    const detail: { page: number } = customEvent.detail;
    if(this.inviteTeacher) {
      this.paginationService['current'] = detail.page;
      if(this.search.value == this.EMPTY_STRING) {
        this.onPageChange();
      }
    } else {
      this.paginationStore['current'] = detail.page;
    }
    this._loadTeachersInDataTable();
  }

  public refreshDataTable(): void {
    this._loadTeachersInDataTable();
  }

  private _loadTeachersInDataTable(): void {
    if (!this.dataTable || !this.dataTable.loadData) {
      return;
    }

    const items = this.inviteTeacher ? this.teachersOrg : this.classTeachers;
    if (!items || items.length == 0) {
      this.dataTable.loadData({ items: [], headers: this.headers });
      return;
    }

    const itemsPerPage = this._getItemsPerPage();
    itemsPerPage.forEach(v => v.id = v.id ?? v.person.id);
    
    const slots = {
      'item.username' : {
        template: '{item.username}',
        templateParams: [{
          key: 'item.username',
          value: (params) => params.item.username || (params.item.person ? params.item.person.userId : this.EMPTY_STRING),
        }],
      },
      'item.firstName' : {
        template: '{item.firstName}',
        templateParams: [{
          key: 'item.firstName',
          value: (params) => params.item.firstName || (params.item.person ? params.item.person.firstName : this.EMPTY_STRING),
        }],
      },
      'item.lastName' : {
        template: '{item.lastName}',
        templateParams: [{
          key: 'item.lastName',
          value: (params) => params.item.lastName || (params.item.person ? params.item.person.lastName : this.EMPTY_STRING),
        }],
      },
      'item.email' : {
        template: '{item.email}',
        templateParams: [{
          key: 'item.email',
          value: (params) => params.item.email || (params.item.person ? params.item.person.email : this.EMPTY_STRING),
        }],
      },
      'item.teacherType' : {
        template: '{item.teacherType}',
        templateParams: [{
          key: 'item.teacherType',
          value: (params) => {
            const type = params.item.person ? params.parent.getTeacherTypeName(params.item.type) : params.parent.getTeacherTypeName(params.parent.getTeacherType(params.item));
            return type?? this.EMPTY_STRING;
          },
        }],
      },
      'item.mainTeacher': {
        template: document.querySelector('#item\\.mainTeacher').innerHTML,
        templateParams: [{
        }],
        expressions: [
          {
            target: '.vRadio', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent._validateSubstituteTeacher(params) && !params.parent._isSubstituteTeacherType(params),
            applied: 'display: inline;', fallback: 'display: none;', concat: true
          },
          {
            target: '.vRadioFalse', attribute: 'style', booleanAttribute: false,
            expression: (params) => {
              return !(params.parent._validatePersonIdAsTeacher(params));
            },
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.vRadioTrue', attribute: 'style', booleanAttribute: false,
            expression: (params) => {
              return params.parent._validatePersonIdAsTeacher(params);
            },
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.vRadioDisable', attribute: 'class', booleanAttribute: false,
            expression: (params) => params.parent._validatePersonIdAsTeacher(params) || 
                                    !params.parent.writeClassPriv ||
                                    params.parent.isCalendarExpired,
            applied: 'v-radio--is-disabled', fallback: 'display:none', concat: true
          },
          {
            target: 'input[type="radio"]', attribute: 'checked', booleanAttribute: true,
            expression: (params) => {
              const personId = params.parent.inviteTeacher ? params.item.personId : params.item.person?.id;
              return personId === params.parent.classItem.teacher.id;
            },
            applied: 'true', fallback: 'false',
          },
        ],
        events: [
          {
            target: '.updateMainTeacherConfirm', handler: (params) => {
              return (params.parent._validatePersonIdAsTeacher(params)) ? null : params.parent.updateMainTeacherConfirm(params.item);
            }
          },
        ]
      },
      'item.actions': {
        template: document.querySelector('#item\\.actions').innerHTML,
        templateParams: [{
        }],
        expressions: [
          {
            target: '.spinner', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent.loadingAdd && (params.parent.addObj.personId === params.item.personId),
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.actionButtons', attribute: 'style', booleanAttribute: false,
            expression: (params) => !params.parent.loadingAdd,
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.hideActions', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent._validatePersonIdAsTeacher(params),
            applied: 'display: none;', fallback: 'display: inline;'
          },
          {
            target: '.showMainTeacher', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent._validatePersonIdAsTeacher(params),
            applied: 'display: inline;', fallback: 'display: none;', concat: true
          },
          {
            target: '.showCoTeacher', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent._validateSubstituteTeacher(params) && !params.parent._isSubstituteTeacherType(params),
            applied: 'display: inline;', fallback: 'display: none;', concat: true
          },
          {
            target: '.addTeacher', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent.inviteTeacher && params.parent.classTeachers.findIndex(el => el.person.id === params.item.personId) === -1 && (params.parent.addObj.personId !== params.item.personId),
            applied: 'display: inline;', fallback: 'display: none;', concat: true
          },
          {
            target: '.removeTeacher', attribute: 'style', booleanAttribute: false,
            expression: (params) => (params.parent._validateSubstituteTeacher(params) && !params.parent._isSubstituteTeacherType(params)) && (params.parent.isMainTeacher || params.parent.writeClassPriv),
            applied: 'display: inline;', fallback: 'display: none;', concat: true
          },
          {
            target: '.removeTeacher', attribute: 'class', booleanAttribute: false, concat: true,
            expression: (params) =>  params.parent.isCalendarExpired,
            applied: 'ed-icon-disabled', fallback: ' '
          },
        ],
        events: [
          { target: '.addTeacher', handler: (params) => params.parent.addTeacherToClass(params.item)},
          { target: '.removeTeacher', handler: (params) =>  params.parent.deleteItem(params.item) },
        ]
      },
      parent: this,
    };

    this.dataTable.loadData({
      items: itemsPerPage,
      headers: this.headers,
      slots: slots,
    });
  }

  private _validatePersonIdAsTeacher(params: any): boolean {
    return params.item.personId === params.parent.classItem.teacher.id || (params.item.person && params.item.person.id === params.parent.classItem.teacher.id);
  }

  private _validateSubstituteTeacher(params): boolean  {
    return !params.parent.substituteTeacher(params.item) && params.parent.classTeachers.find(el => el.person.id === params.item.personId || (params.item.person && el.person.id === params.item.person.id));
  }

  private _isSubstituteTeacher(params): boolean  {
    return params.parent.substituteTeacher(params.item) && params.parent.classTeachers.find(el => el.person.id === params.item.personId || (params.item.person && el.person.id === params.item.person.id));
  }

  private _isSubstituteTeacherType(params): boolean {
    const type = params.item.person ? params.item.type : params.parent.getTeacherType(params.item);
    return type === 'SUBSTITUTE_TEACHER';
  }

  private _getItemsPerPage(): any[] {
    if(this.inviteTeacher) {
      if(this.search.value == this.EMPTY_STRING) {
        return this.teachersOrg;
      } else {
        return this._getItemsPerPageByPagitacion(this.paginationService, this.teachersOrg);
      }  
    } else {
      return this._getItemsPerPageByPagitacion(this.paginationStore, this.classTeachers);
    }
  }

  private _getItemsPerPageByPagitacion(pagination: object, data: any): any[] {
    const start = (pagination['current'] - 1) * this.ROWS_PER_PAGE;
    const end = start + this.ROWS_PER_PAGE;
    return data.slice(start, end);
  }

  private _loadPaginationData(data: any, pagination: object): void {
    if(data.length <= this.ROWS_PER_PAGE) {
      pagination['total'] = 1;
    } else {
      const numFloor = (data.length / this.ROWS_PER_PAGE);
      if(Number.isInteger(numFloor)) {
        pagination['total'] = numFloor;
      } else {
        const floor = Math.floor((data.length / this.ROWS_PER_PAGE) + 1);
        const max = Math.max(floor, 1);
        pagination['total'] = max;
      }
    }
    pagination['current'] = 1;
  }

  private _onLanguageChanged(lang: string): void {
    this.dataTable?.setAttribute('lang', lang);
    this.$nextTick(() => {
      this._loadTeachersInDataTable();
    });
  }

  /* Hooks */
  updated() {
    this.mainTeacherRadio = true
  }

  created() {
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
  }

  beforeDestroy() {
    this.$edEventBus.$off(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
  }

   /* Watch */
  @Watch('classItem', { immediate: true, deep: true })
  getTeachersByClass(oldVal, newVal) {
    if (!oldVal || !newVal || oldVal.id !== newVal.id) {
      this.inviteTeacher = false;
      this.search.value = this.EMPTY_STRING;
      this.$store.commit(CLASSES_STORE.MUTATIONS.CLEAR_TEACHERS_M);
      this.getClassTeachers();
    }
  }

  @Watch('search.value', { immediate: true, deep: true })
  private _watchSearch(value): void {
    if (!this.loading || value == null || value === '') {
      this.searchStudents();
    }
  }

  searchStudents() {
    if (this.search.value == this.EMPTY_STRING) {
      this.teachersOrg = this.pagedOrganizationTeachers.find(el => el.page === 0)?.content;
    } else {
      this.$store.dispatch(`${CLASSES_STORE.ACTIONS.SEARCH_USERS_ORGANIZATION_A}`,{
        orgId: this.orgId,
        userTypes: 'TEACHER,SDA,SA',
        keyword: this.search.value
      }).then((res) => {
        this.teachersOrg = res.content;
        this._loadPaginationData(this.teachersOrg, this.paginationService);
      }).catch(() => {
        this.teachersOrg = []
      })
    }
  }

  @Watch('teachersOrg', { immediate: true, deep: true })
  private _watchTeachersOrg(): void {
    this.$nextTick(() => {
      setTimeout(() => {
        if(!this.teachersOrg) {
          return;
        }
        this._loadTeachersInDataTable();
      }); 
    });
  }

  @Watch('classTeachers', { immediate: true, deep: true })
  private _watchClassTeachers(): void {
    this.$nextTick(() => {
      setTimeout(() => {
        this._loadPaginationData(this.classTeachers, this.paginationStore);
        this._loadTeachersInDataTable();
      }); 
    });
  }
}